import { render, staticRenderFns } from "./AdminBoard.vue?vue&type=template&id=7aa540c6"
import script from "./AdminBoard.vue?vue&type=script&lang=js"
export * from "./AdminBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports